module.exports = __webpack_public_path__ + "img/rocket.a008b707.png";